import { memo } from 'react';
import PropTypes from 'prop-types';
import { FaCheck, FaTimes } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { refundableStatuses, RefundableStatusLabels, SearchStatus } from '../../../../constants';
import Label from '../../../Label';
import getRateOptionRulesKey from '../../../../helpers/getRateOptionRulesKey';
import getCruiseRateRefundability from '../../../../helpers/getCruiseRateRefundability';
import RateRulesDescription from '../../RateRules/RateRulesDescription';
import formatStateroomsForRequest from '../../../../helpers/formatters/formatStateroomsForRequest';

const CruiseRateCancellationLabel = ({
  itineraryId, rateOptionCode, selectedRoomIndex, doShowRateRuleOnHover, rateOptionRules,
  cruiseLineId,
}) => {
  const allRateOptionRules = useSelector((store) => store.trip.rateOptionRules);
  const staterooms = useSelector((state) => state.tripSearch.searchObj.staterooms);
  const { pastPassengerNumber } = formatStateroomsForRequest(staterooms
    && staterooms[selectedRoomIndex], cruiseLineId);
  let rateOptionRulesToView = (rateOptionRules || {}).rateOptionRules;

  if (!rateOptionRulesToView) {
    const rateOptionKey = getRateOptionRulesKey({
      itineraryId, rateOptionCode, roomIndex: selectedRoomIndex, pastPassengerNumber,
    });

    if (!allRateOptionRules[rateOptionKey]
      || allRateOptionRules[rateOptionKey].getRateRulesStatus === SearchStatus.SEARCHING) {
      return <></>;
    }

    rateOptionRulesToView = allRateOptionRules[rateOptionKey].rateOptionRules;
  }

  const refundableStatus = getCruiseRateRefundability(rateOptionRulesToView);
  const labels = {
    [refundableStatuses.REFUNDABLE]: {
      level: 'success',
      icon: <FaCheck />,
      text: RefundableStatusLabels[refundableStatus],
    },
    [refundableStatuses.NON_REFUNDABLE]: {
      level: 'danger',
      icon: <FaTimes />,
      text: RefundableStatusLabels[refundableStatus],
    },
    [refundableStatuses.NO_INFO]: {
      text: RefundableStatusLabels[refundableStatus],
    },
  };

  const labelDescriptionOnHover = () => {
    if (doShowRateRuleOnHover) {
      if ((rateOptionRulesToView || []).length) {
        return <RateRulesDescription rateOptionRules={rateOptionRulesToView} />;
      }
      return 'Could not find rate rules!';
    }
    return null;
  };

  if (refundableStatus) {
    return (
      <Label
        text={labels[refundableStatus].text}
        icon={labels[refundableStatus].icon}
        level={labels[refundableStatus].level}
        italic
        descriptionOnHover={labelDescriptionOnHover()}
        tooltipPlacement="left"
      />
    );
  }
  return <></>;
};

CruiseRateCancellationLabel.propTypes = {
  itineraryId: PropTypes.string,
  rateOptionCode: PropTypes.string.isRequired,
  selectedRoomIndex: PropTypes.number.isRequired,
  doShowRateRuleOnHover: PropTypes.bool,
  rateOptionRules: PropTypes.arrayOf(PropTypes.shape({})),
  cruiseLineId: PropTypes.number.isRequired,
};

CruiseRateCancellationLabel.defaultProps = {
  itineraryId: undefined,
  doShowRateRuleOnHover: false,
  rateOptionRules: [],
};

export default memo(CruiseRateCancellationLabel);
